import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Header2 from './../Common/Header2';
import SEO from './../Common/SEO';
import Banner from './../Elements/Banner';
import Footer2 from '../Common/Footer2';

const bnrimg = require('./../../images/banner/7.jpg');

// ⚠️ Pagination API (QUERY BASED)
const BLOG_LIST_URL = 'https://www.admin.infrioindia.com/api/v2/auth/blog-list';

function BlogGrid() {
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    let cancelled = false;

    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError(null);

        const url = `${BLOG_LIST_URL}?page=${currentPage}&per_page=${perPage}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        });

        // 🔥 FIX: HTML error catch
        const text = await response.text();

        let result;
        try {
          result = JSON.parse(text);
        } catch (e) {
          throw new Error('API JSON नहीं दे रही, HTML return हो रहा है (check 405/404)');
        }

        if (!response.ok) {
          throw new Error(result?.message || 'API Error');
        }

        if (!cancelled) {
          const list = result?.data || [];
          setApiData(list);

          // pagination safe handling
          const total = result?.total || list.length;
          setTotalPages(Math.ceil(total / perPage));
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setApiData([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchBlogs();

    return () => {
      cancelled = true;
    };
  }, [currentPage, perPage]);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <>
      <SEO
        titleExact
        title="Architecture and Interior Design Blog – Infrio India"
        description="Read Infrio India blog..."
        keywords="architecture blog india"
        canonicalPath="/blog"
      />

      <Header2 />

      <div className="page-content">
        <Banner
          title="Blogs"
          pagename="Blogs"
          description="Architecture & Interior Insights"
          bgimage={bnrimg}
        />

        <div className="section-full p-tb80 bg-white inner-page-padding">
          <div className="container">

            {/* LOADING */}
            {loading && (
              <div className="text-center p-5">Loading...</div>
            )}

            {/* ERROR */}
            {!loading && error && (
              <div className="text-center text-danger p-5">
                {error}
              </div>
            )}

            {/* EMPTY */}
            {!loading && !error && apiData.length === 0 && (
              <div className="text-center p-5">
                No blogs found
              </div>
            )}

            {/* GRID */}
            <div className="row">
              {apiData.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={item?.id || index}>
                  <div className="blog-post blog-grid h-100">

                    <div className="sx-post-media">
                      <NavLink to="/blog-detail" state={{ id: item?.id }}>
                        <img src={item?.banner} alt={item?.title} />
                      </NavLink>
                    </div>

                    <div className="sx-post-info p-3">
                      <h4 style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}>
                        <NavLink to="/blog-detail" state={{ id: item?.id }}>
                          {item?.title}
                        </NavLink>
                      </h4>

                      <NavLink
                        to="/blog-detail"
                        state={{ id: item?.id }}
                        className="site-button-link"
                      >
                        View More
                      </NavLink>
                    </div>

                  </div>
                </div>
              ))}
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <div className="text-center mt-4">
                <ul className="pagination justify-content-center">

                  <li>
                    <button
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      «
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, i) => (
                    <li key={i}>
                      <button
                        style={{
                          fontWeight: currentPage === i + 1 ? "bold" : "normal",
                          color: currentPage === i + 1 ? "#d7b39a" : "#000"
                        }}
                        onClick={() => goToPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li>
                    <button
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      »
                    </button>
                  </li>

                </ul>
              </div>
            )}

          </div>
        </div>
      </div>

      <Footer2 />
    </>
  );
}

export default BlogGrid;